const lessonData = {
        1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [
            {
              alt: "An empty subway car",
              image:
                "https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/pexels-pixabay-302428.jpg",
              order: 0,
            },
          ],
          layoutNumber: 3,
          navigation: [
            { available_scene: "2", current_scene: "1", previous_scene: null, text: "Continue" },
          ],
          scene_number: "1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [],
          title: `Religious "Nones?"`,
          videos: [],
          audio: [],
        },
        2: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "3", current_scene: "2", previous_scene: "1",text: "Continue" },
          ],
          scene_number: "2",
          sidebar: true,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [`<p>For more information on the Pew Research Center study, read the <a href="https://www.pewresearch.org/religion/2024/01/24/religious-nones-in-america-who-they-are-and-what-they-believe/" target="_blank">"Religious ‘Nones’ in America: Who They Are and What They Believe"</a> article.</p>`],
          text: [
            `<p>As demographics shift in the United States, chaplains may encounter people who no longer identify with a set religious tradition. They may see themselves as agnostic or atheist, or perhaps "spiritual but not religious." And what about those people who have no religious or spiritual identity? These groups of people should have access to spiritual care just as any other person would, and it is up to the chaplain to figure out how to relate to them.</p><p>Chaplains can serve this growing population through active listening, a ministry of presence, and "meaning making."</p>`,
          ],
          title: "Non-religious people and spiritual care",
          videos: [],
          audio: [],
        },
        3: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "4", current_scene: "3", previous_scene: "2", text: "Continue" },
          ],
          scene_number: "3",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Non-religious people may seem like challenging folks to relate with as the usual "reference points" of religious or spiritual language are not present. Non-religious people may not even think a chaplain is right for them.</p><p>However, chaplains can communicate our value to non-religious people by sharing that we listen to and support all people who are going through difficult times.</p>`,
          ],
          title: null,
          videos: [],
          audio: [],
        },
        4: {
          checkpoint: false,
          last: false,
          checkpoints: [{
            alt: null,
            answer: false,
            content_type: 5,
            data:
              "<p>Have you worked with non-religious people as a chaplain? What other tips would you add to this list?</p>",
            order: 0,
            question_type: 2,
            scene_number: "4",
            sidebar: false,
          },],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "5", current_scene: "4", previous_scene: "3",text: "Continue" },
          ],
          scene_number: "4",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>While some non-religious people may be curious about speaking with a chaplain, others may be more resistant. You may have to take creative approaches to engage them.</p><ul><li><strong>Explain your role as a member of a care team.</strong> A non-religious person may associate a chaplain with a clergy member, or think that you are trying to convert them to your religion.<ul><li>Start the conversation by asking questions about what support the person needs and what support they’re currently receiving. Ask a non-religious person what they think when they hear the word “chaplain” and help to demystify their perception of you, too! Emphasize that you are available as a member of their care or support team who is focused on helping them through challenging times.</li></ul></li><li><strong>Be present and practice active listening.</strong> When you practice active listening, you pay attention to another person’s words, body language, and feelings, without trying to push your own agenda onto the conversation.<ul><li>A non-religious person may be explicit about their concerns about religion or spirituality - stating their complete disinterest in working with you - or they may be more implicit, communicating hesitations through words, movement, and tone. Pay attention to what a person is saying and how they are saying it to meet them where they are at in the moment.</li></ul></li><li><strong>Practice non-judgemental thinking and openness.</strong> You may feel yourself reacting to a non-religious person’s dismissal of spirituality or religion. It may feel like a personal attack on you and your deeply held perspectives.<ul><li>Try to see the situation from the non-religious person’s perspective and imagine what it would feel like to hold <i>their</i> perspectives. Ask open-ended questions. Show interest in their situation.</li></ul></li></ul>`,
          ],
          title: "Effective ways of working with non-religious people",
          videos: [],
          audio: [],
        },
        5: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6", current_scene: "5", previous_scene: "4",text: "Continue" },
          ],
          scene_number: "5",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You will likely have a difficult time working with non-religious people if you:</p><ul><li>Try to convince someone to become religious when they are not.</li><li>Dismiss non-religious people altogether in your chaplaincy.</li><li>Avoid discussing important issues and aiding in meaning-making.</li><li>Get caught up in philosophical debates about religion or spirituality.</li></ul><p>Your goal as a chaplain is to help people make sense of their situations, meeting them where they are at in the moment. Attempting to convert someone to your religion or debating the tenets of a non-religious person’s perspectives derail you from this goal.</p><p>It's also important that you do attempt to meet with non-religious people and when you do, you go beyond having a social visit. You should attempt to help religious and non-religious people seek meaning through their situations - regardless of their spiritual perspectives, or indifference.</p>`,
          ],
          title: "Non-effective ways of working with non-religious people",
          videos: [],
          audio: [],
        },
        6: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [ ],
          layoutNumber: 4,
          navigation: [
            { available_scene: "6.1", current_scene: "6", previous_scene: "5",text: "Continue" },
          ],
          scene_number: "6",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In the next section of this lesson, you will meet three non-religious people in different situations. You will play the role of the chaplain, who must make decisions about how to engage with each of these people, to the best of your ability. You will receive feedback about the choices you make along the way.</p>`,
          ],
          title: "Scenarios",
          videos: [],
          audio: [],
        },    
        6.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [{alt:'Abe', image: 'https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/pexels-mikhail-nilov-6973110.jpg', order: 0}],
          layoutNumber: 1,
          navigation: [
            { available_scene: "7", current_scene: "6.1", previous_scene: "6",text: "Continue" },
          ],
          scene_number: "6.1",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In this scenario, you will meet Abe. Abe is an 74 year old, culturally Jewish, white man. He is a retired University professor. Abe and his wife recently moved into a senior living facility.</p><p>At each decision point, determine what you will do to best serve Abe in your role as a chaplain.</p>`,
          ],
          title: "Meet Abe",
          videos: [],
          audio: [],
        },
        7: {
          checkpoint: false,
          last: false,
          checkpoints: [{
            alt: null,
            answer: false,
            content_type: 5,
            data:
              "<p>What went well in this situation? What tactics did the chaplain use to engage Abe effectively?</p><p>What went poorly in this situation? What did the chaplain do that could have alienated Abe?</p>",
            order: 0,
            question_type: 2,
            scene_number: "7",
            sidebar: false,
          }],
          images: [],
          layoutNumber: 9,
          navigation: [
            { available_scene: "8", current_scene: "7", previous_scene: "6.1",text: "Continue" },
          ],
          scene_number: "7",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Abe’s wife, Rebecca, is beginning to show signs of dementia. Rebecca has a strong connection to Judaism as a religion, but her new memory problems have prevented her from accessing religious and spiritual care in the senior living facility. After Abe expresses his concerns to a member of his medical team, Abe is connected with you, the chaplain on staff, for support.</p>
            `,
          ],
          title: "Meet Abe",
          videos: [],
          audio: [`https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/492767__h0ugh__ambience-house-with-tv.wav`],
        },
        8: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [{alt:'James', image: 'https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/pexels-thomas-chauke-437438-6573803.jpg', order: 0}],
          layoutNumber: 1,
          navigation: [
            { available_scene: "9", current_scene: "8", previous_scene: "7", text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In this scenario, you will meet James. James is a 17 year-old black, non-binary, high school junior who attends a private high school.</p><p>At each decision point, determine what you will do to best serve Abe in your role as a chaplain.</p>`,
          ],
          title: "Meet James",
          videos: [],
          audio: [],
        },
        9: {
          checkpoint: false,
          last: false,
          checkpoints: [{
            alt: null,
            answer: false,
            content_type: 5,
            data:
              "<p>What went well in this situation? What tactics did the chaplain use to engage James effectively?</p><p>What went poorly in this situation? What did the chaplain do that could have alienated James?</p>",
            order: 0,
            question_type: 2,
            scene_number: "9",
            sidebar: false,
          }],
          images: [],
          layoutNumber: 7,
          navigation: [
            { available_scene: "9.1", current_scene: "9", previous_scene: "8",text: "Continue" },
          ],
          scene_number: "9",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            ` <p>James has typically been a strong student with consistent grades across subjects. However, during the first semester of their junior year, their teachers begin to see their grades fluctuating wildly and their attention in class being underperforming. James has opened up to their theater teacher that their very religious parents are "getting on their nerves." The theater teacher suggests they see the school chaplain, you, for support.</p>`,
          ],
          title: `Meet James`,
          videos: [],
          audio: [`https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/324992__alexschmidtmeister__high_school_germany_indoor_ambience_before_class.wav`],
        },
        9.1: {
          checkpoint: false,
          last: false,
          checkpoints: [],
          images: [{alt:'Luz', image: 'https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/Homeless_woman_in_Washington%2C_D.C..jpg', order: 0}],
          layoutNumber: 1,
          navigation: [
            { available_scene: "10", current_scene: "9.1", previous_scene: "9",text: "Continue" },
          ],
          scene_number: "8",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>In this scenario, you will meet Luz. Luz is a 49 year-old Latina woman who is currently unhoused. She grew up Catholic, but has experienced significant trauma through the church and no longer identifies as religious.</p><p>At each decision point, determine what you will do to best serve Abe in your role as a chaplain.</p>`,
          ],
          title: "Meet Luz",
          videos: [],
          audio: [],
        },
        10: {
          checkpoint: false,
          last: false,
          checkpoints: [{
            alt: null,
            answer: false,
            content_type: 5,
            data:
              "<p>What went well in this situation? What tactics did the chaplain use to engage Luz effectively?</p><p>What went poorly in this situation? What did the chaplain do that could have alienated Luz?</p>",
            order: 0,
            question_type: 2,
            scene_number: "10",
            sidebar: false,
          }],
          images: [],
          layoutNumber: 8,
          navigation: [
            { available_scene: "19", current_scene: "10", previous_scene: "9.1",text: "Continue" },
          ],
          scene_number: "10",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>Luz recently got a full-time job in a warehouse that could have helped her get back into stable housing. However, two weeks into the job, she injures her back so badly that she has to take time off work. She’s not sure if she will ever be able to make it back to that job. </p>`,
          ],
          title: `Meet Luz`,
          videos: [],
          audio: [`https://chaplaincy-innovation-lab-lessons.s3.amazonaws.com/nonreligious/203929__floatingpatterns__under-the-dorogomilovsky-bridge-highway.wav`],
        },
      
        19: {
          checkpoint: false,
          last: true,
          checkpoints: [],
          images: [],
          layoutNumber: 6,
          navigation: [{available_scene: "19", current_scene: "19", previous_scene: "10",text: "End Lesson" }],
          scene_number: "19",
          sidebar: false,
          sidebarImages: [],
          sidebarVideos: [],
          sidebarText: [],
          text: [
            `<p>You finished this lesson! In this lesson, you encountered three non-religious people who were struggling with a big challenge. You used active listening, a ministry of presence, and creative, non-judgemental thinking to engage each of these people and hopefully put them on a path towards meaning-making for themselves. </p>`
          ],
          title: "Lesson complete",
          videos: [],
          audio: [],
        },
      };
    
export default lessonData;
